import { render, staticRenderFns } from "./TicketsCartButton.vue?vue&type=template&id=2a0b2beb&scoped=true"
import script from "./TicketsCartButton.vue?vue&type=script&lang=js"
export * from "./TicketsCartButton.vue?vue&type=script&lang=js"
import style0 from "./TicketsCartButton.vue?vue&type=style&index=0&id=2a0b2beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b2beb",
  null
  
)

export default component.exports